import { Routes } from '@angular/router';
import { AuthGuard } from 'core/guards/auth.guard';
import { UnAuthGuard } from 'core/guards/unauth.guard';
import { AuthLayout } from 'shared/components/layouts/auth-layout/auth-layout';
import { MainLayout } from 'shared/components/layouts/main-layout/main-layout';
import { SITE_ROUTES } from 'shared/enums/routes.enum';

export const routes: Routes = [
    {
        path: 'app',
        component: MainLayout,
        children: [
            {
                path: 'dashboard',
                loadChildren: () => import('./features/dashboard/dashboard.routes')
                    .then(m => m.DASHBOARD_ROUTES),
            },
            {
                path: 'companies',
                loadChildren: () => import('./features/companies/companies.routes')
                    .then(m => m.COMPANIES_ROUTES),
            },
            {
                path: 'commission',
                loadChildren: () => import('./features/commission/commission.routes')
                    .then(m => m.COMMISSION_ROUTES),
            },
            {
                path: 'affiliation',
                loadChildren: () => import('./features/affiliation/affiliation.routes')
                    .then(m => m.AFFILIATION_ROUTES),
            },
            {
                path: 'tickets',
                loadChildren: () => import('./features/tickets/tickets.routes')
                    .then(m => m.TICKETS_ROUTES),
            },
            {
                path: '**',
                redirectTo: SITE_ROUTES.LOGIN
            },
        ],
        canActivateChild: [AuthGuard]
    },
    {
        path: 'auth',
        component: AuthLayout,
        children: [
            {
                path: '',
                loadChildren: () => import('./features/auth/auth.routes')
                    .then(m => m.AUTH_ROUTES)
            }
        ],
        canActivateChild: [UnAuthGuard]
    },
    {
        path: '**',
        redirectTo: SITE_ROUTES.LOGIN.replace('/', '')
    },
];

